import { faCalendarCheck, faCreditCard, faIdCard, faRepeat, faStar, faTags, faTicket, faUsers } from "@fortawesome/free-solid-svg-icons";
import { Box, Button, Container, Grid, Paper, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Service from "../../components/Service";
import ContactUs2 from "./contactUs2";

export default function MerchantServices(){
    const {t, i18n} = useTranslation();
    const history = useHistory();
    const theme = useTheme();


    const redirect = (route) => {
        history.push(route);
    }

    const services = [
        {
            icon:faTicket,
            title:{es:'Gestión de Eventos', en:'Event Management'},
            description:{
                es:`Vende entradas, controla el acceso y gestiona a tus asistentes de forma profesional y sin complicaciones`, 
                en:`Seamlessly sell tickets, control access, and manage attendees for a professional, hassle-free event experience`
            }
        },
        {
            icon:faStar,
            title:{es:'Sistema de Reseñas', en:'Customer Reviews'},
            description:{
                es:`Construye confianza y mejora tu reputación recopilando y mostrando las valiosas opiniones de tus clientes`, 
                en:`Build trust and enhance your reputation by collecting and showcasing valuable feedback from your customers`
            }
        },
        {
            icon:faTicket,
            title:{es:'Landing Pages', en:'Landing Pages'},
            description:{
                es:`Crea una página de presentación profesional para tu negocio o evento en minutos`, 
                en:`Launch a professional landing page for your business or event in minutes`
            }
        },
        {
            icon:faTicket,
            title:{es:'Catálogo Digital', en:'Digital Catalogue/Menu'},
            description:{
                es:`Muestra tus productos, servicios o menú de forma atractiva y organizada a tus clientes`, 
                en:`Showcase your products, services, or menu in an attractive and organized catalog for your customers`
            }
        },
        {
            icon: faCreditCard, // O faWallet
            title: {
                es: 'Cashless',
                en: 'Cashless Payments'
            },
            description: {
                es: 'Moderniza la experiencia de pago en tus eventos o negocio con un sistema sin efectivo, más rápido y seguro para todos.',
                en: 'Modernize the payment experience at your events or business with a faster, more secure cashless system for everyone.'
            }
        },
        {
            icon: faIdCard,
            title: {
                es: 'Tarjetas de Presentación Inteligentes',
                en: 'Smart Business Cards'
            },
            description: {
                es: 'Conecta de forma innovadora. Comparte tu información de contacto, redes y más con una tarjeta digital interactiva.',
                en: 'Connect in an innovative way. Share your contact information, social networks, and more with an interactive digital card.'
            }
        },
        {
            icon: faTags, // O faGift
            title: {
                es: 'Cupones de Descuento',
                en: 'Discount Coupons'
            },
            description: {
                es: 'Fideliza a tus clientes y atrae nuevos con cupones digitales fáciles de crear, distribuir y canjear.',
                en: 'Build customer loyalty and attract new ones with digital coupons that are easy to create, distribute, and redeem.'
            }
        },
        {
            icon: faCalendarCheck,
            title: {
                es: 'Gestión de Reservaciones',
                en: 'Booking Management'
            },
            description: {
                es: 'Optimiza tu agenda y evita sobrecupos. Permite que tus clientes reserven citas o mesas de forma sencilla y online.',
                en: 'Optimize your schedule and avoid overbooking. Allow your customers to easily book appointments or tables online.'
            }
        },
        {
            icon: faRepeat, // O faSync
            title: {
                es: 'Suscripciones',
                en: 'Subscriptions'
            },
            description: {
                es: 'Genera ingresos recurrentes y crea una comunidad fiel con planes de membresía y contenido exclusivo.',
                en: 'Generate recurring revenue and build a loyal community with membership plans and exclusive content.'
            }
        },
        {
            icon: faUsers,
            title: {
                es: 'Gestión de Clientes (CRM)',
                en: 'Customer Management (CRM)'
            },
            description: {
                es: 'Conoce mejor a tus clientes. Centraliza su información, historial y preferencias para ofrecer un servicio personalizado.',
                en: 'Get to know your customers better. Centralize their information, history, and preferences to offer personalized service.'
            }
        }

    ];

    return(
        <Box>
            <Container maxWidth='xl' sx={{paddingTop:{xs:20,lg:20}, paddingBottom:{xs:10,lg:10}}}>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Paper elevation={0} sx={{borderRadius:10,pt:10,pb:10,bgcolor:'#ebeef6'}}>
                            <Grid container spacing={3}>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <Typography variant='h3' component={'h1'} color={'primary.main'} fontWeight={'bold'} textAlign={'center'} gutterBottom={3}>
                                        {t('services.title')}
                                    </Typography>
                                    <Typography variant='h6' component={'h1'} color={'#5A5A5A'} textAlign={'center'} sx={{whiteSpace:'pre-line'}}>
                                        {t('services.description')}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{display:'flex',justifyContent:'center'}}>
                                    <Button variant='contained' style={{borderRadius:30}} onClick={()=>redirect('/auth/merchantSignUp')}>
                                        <Typography variant='h6'>
                                            &nbsp;&nbsp;{t('helpers.getStarted')}&nbsp;&nbsp;
                                        </Typography>
                                    </Button>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Grid container spacing={3}>
                            {
                                services.map((service, index) => (
                                    <Grid item xs={12} sm={6} md={4} lg={4} xl={4} key={index}>
                                        <Service
                                            elevation={4}
                                            icon={service.icon}
                                            title={i18n.language === 'es' ? service.title.es : service.title.en}
                                            description={i18n.language === 'es' ? service.description.es : service.description.en}
                                        />
                                    </Grid>
                                ))
                            }
                        </Grid>
                    </Grid>
                </Grid>
            </Container>
            {/**Contactanos */}
            <ContactUs2
                title={t('contactUs.title2')}
                description={t('contactUs.text')}
                buttonText={t('contactUs.buttonText')}
            />
        </Box>
    )
}